import { createReducer, on } from "@ngrx/store";
import { ConnectionActions } from "../actions/connection.actions";
import { initialState } from "../states/connection.state";

export function sortConnectionsByDisplayName(connections: any[]): any[] {
  return [...(connections || [])].sort((a, b) =>
    (a.meta.displayName ?? '').toLowerCase().localeCompare((b.meta.displayName ?? '').toLowerCase())
  );
}

export const connectionsReducer = createReducer(
  initialState,
  on(ConnectionActions.createConnection, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ConnectionActions.createConnectionSuccess, (state, { connection }) => {
    const validKeys = ["ALM", "LLM", "LLM_PARSER", "FILE", "DATABASE"] as const;
    const connectionType =
      connection?.connectionType.toUpperCase() as keyof typeof state.connection;
    if (!validKeys.includes(connectionType)) {
      return state;
    }
    return {
      ...state,
      loading: false,
      connection: {
        ...state?.connection,
        [connectionType]: [...(state?.connection[connectionType] ?? []), connection],
      },
    };
  }),

  on(ConnectionActions.createConnectionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.message,
  })),

  // Get connections
  on(ConnectionActions.getConnections, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ConnectionActions.getConnectionSuccess, (state, { connection }) => ({
    ...state,
    loading: false,
    connection: {
      ALM: connection?.ALM ? sortConnectionsByDisplayName(connection?.ALM) : [],
      LLM: connection?.LLM ? sortConnectionsByDisplayName(connection?.LLM) : [],
      LLM_PARSER: connection?.LLM_PARSER ? sortConnectionsByDisplayName(connection?.LLM_PARSER) : [],
      FILE: connection?.FILE ? sortConnectionsByDisplayName(connection?.FILE) : [],
      DATABASE: connection?.DATABASE
        ? sortConnectionsByDisplayName(connection?.DATABASE)
        : connection?.DB
          ? sortConnectionsByDisplayName(connection?.DB)
          : [],
    },
  })),
  on(ConnectionActions.getConnectionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.message,
  })),
  //update
  on(ConnectionActions.updateConnection, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ConnectionActions.updateConnectionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.message,
  })),
  on(ConnectionActions.updateConnectionSuccess, (state, { connection }) => {
    const connectionType =
      connection?.connectionType?.toUpperCase() as keyof typeof state.connection;
    return {
      ...state,
      loading: false,
      connection: {
        ...state?.connection,
        [connectionType]: state.connection[connectionType]?.map((conn: any) =>
          conn.id === connection.id ? connection : conn
        ),
      },
    };
  }),
  //delete
  on(ConnectionActions.deleteConnection, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ConnectionActions.deleteConnectionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.message,
  })),
  on(ConnectionActions.deleteConnectionSuccess, (state, { connection }) => {
    return {
      ...state,
      loading: false,
      connection: Object.keys(state.connection).reduce((acc, key) => {
        const typedKey = key as keyof typeof state.connection;
        acc[typedKey] = state.connection[typedKey]?.filter(
          (conn: any) => conn.id !== connection
        );
        return acc;
      }, {} as typeof state.connection),
    };
  }),
  //save file
  on(ConnectionActions.createFileConnection, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ConnectionActions.createFileConnectionSuccess, (state, { connection }) => {
    const validKeys = ["ALM", "LLM","LLM_PARSER", "FILE", "DATABASE"] as const;
    const connectionType =
      connection?.connectionType.toUpperCase() as keyof typeof state.connection;
    if (!validKeys.includes(connectionType)) {
      return state;
    }
    return {
      ...state,
      loading: false,
      connection: {
        ...state?.connection,
        [connectionType]: [...(state?.connection[connectionType] ?? []), connection],
      },
    };
  }),

  on(ConnectionActions.createFileConnectionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.message,
  }))
);
